
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.531 3.768c-.234.497-.28 1.086-.27 1.77 0 .233-.24.115-.24.467 0 .352.12 1.049.48 1.522.36.473.48.59.72.942s.36.744.36 1.056c0 1.174-2.017 1.26-3.174 2.002-.484.31-.816.718-.995 1.223h-.89a.5.5 0 01-.483-.63 1.85 1.85 0 01.835-1.11c.915-.58 2.509-.648 2.509-1.566 0-.245-.095-.551-.285-.827-.19-.275-.285-.367-.57-.737-.284-.37-.38-.916-.38-1.191 0-.276.19-.184.19-.366-.013-.98.121-1.712 1.045-2.205.189-.102.637-.155.85-.155.19-.019.074-.147.298-.195zm.739 1.555c-.018-1.36.165-2.377 1.436-3.063.26-.14.876-.214 1.17-.214.322-.033.003-.296.714-.296s1.7.314 2.172 1.283c.473.97.513 2.033.513 2.289 0 .255.261.127.261.51 0 .382-.113 1.14-.513 1.654s-.531.642-.792 1.024c-.261.383-.392.8-.392 1.148 0 1.276 2.182 1.37 3.447 2.175.685.436 1.089 1.05 1.213 1.84a.5.5 0 01-.494.577H2.539a.5.5 0 01-.494-.58c.127-.789.53-1.401 1.21-1.837 1.259-.805 3.45-.9 3.45-2.175 0-.34-.13-.765-.39-1.148-.262-.382-.392-.51-.784-1.024-.392-.515-.522-1.272-.522-1.654 0-.383.26-.255.26-.509zm6.58-1.57c.501.028 1.146.267 1.465.92.34.699.369 1.465.369 1.649 0 .183.188.091.188.367 0 .275-.081.82-.37 1.19-.288.371-.382.463-.57.738-.188.276-.282.576-.282.827 0 .918 1.571.986 2.482 1.566.43.274.707.645.83 1.113a.5.5 0 01-.484.627h-.447c-.179-.505-.512-.913-.999-1.223-1.164-.741-3.171-.828-3.171-2.002 0-.32.12-.704.36-1.056.24-.352.36-.469.729-.942.368-.473.472-1.17.472-1.522 0-.352-.24-.234-.24-.47 0-.206-.029-.99-.332-1.782z"}})])
          )
        }
      }
    